import React, { useEffect, useCallback } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Button } from "primereact/button";
import { Dialog } from 'primereact/dialog';
import { useTranslation, Trans } from "react-i18next";
import { useNavigate } from "react-router-dom";
import "../Styles/components/Notification.scss";
import DocumentActions from '../Redux/transition/document-upload/document-upload.reducer';
import ProfileActions from "../Redux/actions/profile-actions";

export default function OnboardingNotification(props) {
      const { t } = useTranslation("common");
      const navigate = useNavigate();

      //Redux State from Store
      const defMembership = useSelector((state) => state.defMembership.defMembership);
      const profile = useSelector((state) => state.profile.profile);

      // redux dispatch actions
      const dispatch = useDispatch()
      const getVerificationRecord = useCallback((businessId) => { dispatch(DocumentActions.businessVerificationStatusRequest(businessId)) }, [dispatch]);
      const getProfile = () => dispatch(ProfileActions.profileRequest());

      useEffect(() => {
            if (props.defMembership) {
                  getVerificationRecord(defMembership.business.id);
            }
            if (!profile) {
                  getProfile();
            }
            // eslint-disable-next-line react-hooks/exhaustive-deps
      }, [])

      return (
            <Dialog
                  header={t('login.welcome')}
                  visible={props.visible}
                  style={{ width: "550px", height: "auto" }}
                  onHide={() => props.onHide()}
                  className="tier_dialog"
                  id="tier_dialog"
            >
                  <div className="merchant-onboarding-div">
                        <Trans
                              i18nKey="login.onboarding_intro"
                              values={{ val: profile?.firstName }}
                              components={{
                                    1: <span className="hello_name" />,
                                    2: <span className="dark_texts" />,
                                    3: <span className="dark_texts" />,
                                    4: <span className="blue_texts" />,
                                    5: <br />,
                                    6: <span className="notification_red_txt" />,
                                    7: <span className="purple_styles" />,
                                    8: <div style={{ padding: "0.65rem 0" }} />
                              }}
                        />
                        <p className="notification_hr" />
                        <div className="merchant-onboarding-footer start_application_div">
                              <Button
                                    id="start_application_btn_get"
                                    onClick={() => {
                                          window.open('https://support.paystack.com/en/articles/2125634', '_blank')
                                    }}
                              >
                                    {t("login.get_paystack")}
                              </Button>
                              <Button
                                    id="start_application_btn"
                                    onClick={() => {
                                          props.onHide();
                                          navigate("/payment_providers/payStack")
                                    }}
                              >
                                    {t("login.link_api_key")}
                              </Button>
                        </div>
                  </div>

            </Dialog>
      )
}
